import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { SERIES } from '@/helpers/constants';
import { getCampaignVehicles } from '@/redux/Campaign/campaign.reducer';
import { setAreaHelp } from '@/redux/Help/help.action';
import { AffectedVehicles } from '@/types';
import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InputText from '@/components/UI/InputText/InputText';
import { mapAffectedVehicle } from '@/containers/CampaignDetail/AffectedVehicles/SeriesPanel/SeriesRow/series-row-utils';

interface RestrictionForPlantsProps {
  affectedVehicles: AffectedVehicles;
  setHelpArea: (area: string) => void;
}

const RestrictionForPlants: React.FC<RestrictionForPlantsProps> = (props) => {
  const { affectedVehicles, setHelpArea } = props;
  const { t } = useTranslation();
  const affectedVehicleMapped = mapAffectedVehicle(affectedVehicles);
  const label = affectedVehicleMapped?.typeOfAffectedPlantsSelection === SERIES ? 'affectedVehicles.affectedModelSeries' : 'summary.producedVehicles';
  const plant = affectedVehicleMapped?.affectedPlants?.[0] || {};
  const models = plant?.affectedSeries ? Object.entries(plant?.affectedSeries) : [];
  const value = models?.reduce((acc: string[], [model, versions]: [string, string[]]) => {
    const fullVersions = versions.map((v: string) => `${model}-${v}`);

    return [...acc, ...fullVersions];
  }, [] as string[]);

  return (
    <AccordionPanel
      title={t('plants.restriction', { plant: plant?.plantName })}
      handleClick={() => setHelpArea(SERIES)}
    >
      <InputText
        disabled
        multiline
        id="input-restriction-for-plants"
        label={t(label)}
        value={value.join('  ·  ')}
        className="w-100"
      />
    </AccordionPanel>
  );
};

const mapStateToProps = (state) => ({
  affectedVehicles: getCampaignVehicles(state),
});

const actionCreators = {
  setHelpArea: setAreaHelp,
};

export default connect(mapStateToProps, actionCreators)(RestrictionForPlants);
